<template>
  <div>
    <v-layout row justify-center>
      <v-dialog
        v-model="show"
        fullscreen
        hide-overlay
        persistent
        transition="dialog-bottom-transition"
      >
        <v-card style="background-color: #f5f5f5">
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="onClickCloseModal()">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                class="pa-3"
                style="border-radius: 25px; height: auto;"
                color="secondary"
                @click="generatePDF()"
              >
                <v-icon class="black--text mr-2">
                  mdi-download
                </v-icon>
                <span class="black--text">DESCARGAR PDF</span>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-layout style="background-color: #f5f5f5" align-center justify-center row fill-height>
            <v-flex xs12 md6>
              <v-tabs v-model="selectedTab" centered>
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab v-for="tab in tabs" :key="`title-tab-${tab}`" class="pa-3">
                  {{ tab }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="selectedTab">
                <v-tab-item key="content-tab-0">
                  <v-card flat>
                    <v-card-text>
                      <v-form ref="invoiceForm">
                        <v-layout align-center justify-center column fill-height>
                          <v-flex xs12 class="width-100 mt-3">
                            <v-layout align-start justify-start row fill-height>
                              <v-flex xs12>
                                <h2 class="pl-3">
                                  <template v-if="invoiceType === 'factura'">
                                    Datos de la factura
                                  </template>
                                  <template v-else-if="invoiceType === 'presupuesto'">
                                    Datos del presupuesto
                                  </template>
                                </h2>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12>
                            <v-form ref="InvoiceForm">
                              <v-layout align-center justify-center column fill-height>
                                <v-flex xs12>
                                  <v-layout row wrap>
                                    <v-flex xs12 md6 class="pa-3">
                                      <v-layout
                                        row
                                        wrap
                                        v-if="selectedContactId || invoiceForm.contact_name"
                                      >
                                        <v-flex xs12 md8>
                                          <v-text-field
                                            class="pr-2"
                                            v-model="invoiceForm.contact_name"
                                            label="Nombre"
                                            :readonly="true"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md4>
                                          <v-text-field
                                            class="pl-2"
                                            v-model="invoiceForm.contact_cif"
                                            label="NIF / CIF"
                                            :readonly="true"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md8>
                                          <v-text-field
                                            class="pr-2"
                                            v-model="invoiceForm.contact_address"
                                            label="Dirección"
                                            :readonly="true"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md4>
                                          <v-text-field
                                            class="pl-2"
                                            v-model="invoiceForm.contact_postal_code"
                                            label="Código postal"
                                            :readonly="true"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <v-text-field
                                            class="pr-2"
                                            v-model="invoiceForm.contact_city"
                                            label="Ciudad"
                                            :readonly="true"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                          <v-text-field
                                            class="pl-2"
                                            v-model="invoiceForm.contact_province"
                                            label="Provincia"
                                            :readonly="true"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md8>
                                          <v-text-field
                                            class="pr-2"
                                            v-model="invoiceForm.contact_email"
                                            label="Email"
                                            :readonly="true"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md4>
                                          <v-text-field
                                            class="pl-2"
                                            v-model="invoiceForm.contact_phone"
                                            label="Teléfono"
                                            :readonly="true"
                                          ></v-text-field>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs12 md6 class="pa-3">
                                      <v-text-field
                                        ref="code"
                                        v-model="invoiceForm.code"
                                        :rules="[rules.required]"
                                        :readonly="true"
                                        required
                                      ></v-text-field>
<!--                                      <v-select-->
<!--                                        ref="openbilling_serie_id"-->
<!--                                        v-model="invoiceForm.openbilling_serie_id"-->
<!--                                        :items="billingSeries"-->
<!--                                        item-text="next_serie"-->
<!--                                        item-value="id"-->
<!--                                        :label="`Número de ${invoiceType}`"-->
<!--                                        :readonly="true"-->
<!--                                        @change="onChangeBillingSerie($event)"-->
<!--                                      ></v-select>-->
<!--                                      <v-text-field-->
<!--                                        v-if="invoiceForm.openbilling_serie_id === null"-->
<!--                                        ref="code"-->
<!--                                        :placeholder="`Escribe el número de ${invoiceType}`"-->
<!--                                        v-model="invoiceForm.code"-->
<!--                                        :rules="[rules.required]"-->
<!--                                        :readonly="true"-->
<!--                                        required-->
<!--                                      ></v-text-field>-->
                                      <v-layout row wrap>
                                        <v-flex xs12 v-if="invoiceType === 'presupuesto'">
                                          <v-text-field
                                            ref="date"
                                            :rules="[rules.required]"
                                            v-model="formattedInvoiceDate"
                                            class="pr-2"
                                            label="Fecha de emisión"
                                            readonly
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md6 v-if="invoiceType === 'factura'">
                                          <v-text-field
                                            ref="date"
                                            :rules="[rules.required]"
                                            v-model="formattedInvoiceDate"
                                            class="pr-2"
                                            label="Fecha de emisión"
                                            readonly
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md6 v-if="invoiceType === 'factura'">
                                          <v-text-field
                                            ref="expiration_date"
                                            :rules="[]"
                                            v-model="formattedInvoiceExpirationDate"
                                            class="pl-2"
                                            label="F. vencimiento (opcional)"
                                            readonly
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                          <v-select
                                            ref="invoice_category"
                                            :rules="[]"
                                            v-model="invoiceForm.invoice_category"
                                            :items="invoiceCategories"
                                            label="Categoría"
                                            item-value="value"
                                            item-text="text"
                                            readonly
                                          ></v-select>
                                        </v-flex>
                                        <v-flex xs12>
                                          <v-select
                                            ref="operation_type"
                                            :rules="[]"
                                            v-model="invoiceForm.operation_type"
                                            :items="operationTypes"
                                            label="Tipo de operación"
                                            readonly
                                          ></v-select>
                                        </v-flex>
                                        <v-flex
                                          xs12
                                          v-if="invoiceForm.rectify && invoiceType === 'factura'"
                                        >
                                          <v-select
                                            ref="rectify"
                                            :rules="[]"
                                            disabled
                                            v-model="invoiceForm.rectify"
                                            :items="[
                                              { text: 'No', value: false },
                                              { text: 'Sí', value: true },
                                            ]"
                                            label="Rectificativa"
                                          ></v-select>
                                        </v-flex>
                                        <v-flex
                                          xs12
                                          v-if="invoiceForm.rectify && invoiceType === 'factura'"
                                        >
                                          <v-select
                                            ref="rectify_invoice_id"
                                            :rules="[]"
                                            disabled
                                            v-model="invoiceForm.rectify_invoice_id"
                                            :items="[invoiceForm.invoice_to_rectify]"
                                            item-value="id"
                                            item-text="code"
                                            label="Factura que se rectifica"
                                          ></v-select>
                                        </v-flex>
                                        <v-flex xs12>
                                          <!--                                          <v-label>Estado del cobro</v-label>-->
                                          <v-radio-group
                                            ref="status"
                                            :rules="[]"
                                            v-model="invoiceForm.status"
                                            row
                                            readonly
                                            class="right"
                                          >
                                            <template
                                              v-if="
                                                invoiceType === 'factura' &&
                                                  invoiceForm.status !== 'Rectificada' &&
                                                  !invoiceForm.rectify
                                              "
                                            >
                                              <v-radio label="Impagada" value="Impagada"></v-radio>
                                              <v-radio
                                                label="Pendiente"
                                                value="Pendiente"
                                              ></v-radio>
                                              <v-radio label="Cobrada" value="Cobrada"></v-radio>
                                            </template>
                                            <template v-if="invoiceType === 'presupuesto'">
                                              <v-radio
                                                label="Pendiente"
                                                value="Pendiente"
                                              ></v-radio>
                                              <v-radio label="Aceptado" value="Aceptado"></v-radio>
                                              <v-radio
                                                label="Facturado"
                                                value="Facturado"
                                              ></v-radio>
                                              <v-radio
                                                label="Rechazado"
                                                value="Rechazado"
                                              ></v-radio>
                                            </template>
                                          </v-radio-group>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-form>
                          </v-flex>
                          <v-flex xs12 class="width-100 mt-3">
                            <v-layout align-start justify-start row fill-height>
                              <v-flex xs12>
                                <h2 class="pl-3">
                                  <template v-if="invoiceType === 'factura'">
                                    Detalles de la factura
                                  </template>
                                  <template v-else-if="invoiceType === 'presupuesto'">
                                    Detalles del presupuesto
                                  </template>
                                </h2>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex
                            xs12
                            class="mt-5"
                            v-for="(item, index) in invoiceForm.order_items"
                            :key="`${orderItemsKey}-order-item-${index}`"
                          >
                            <open-billing-order-item-component
                              :ref="`order_item_${index}`"
                              :index="index"
                              :item="item"
                              :invoice-id="invoiceId"
                              :rectify-invoice-id="rectifyInvoiceId"
                              :readonly="true"
                              @order-item-changed="onOrderItemChanged($event)"
                              @order-item-type-changed="onOrderItemTypeChanged($event)"
                            ></open-billing-order-item-component>
                          </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row fill-height>
                          <v-flex xs12 md7 class="mt-4"></v-flex>
                          <v-flex xs12 md5 class="mt-4">
                            <v-card class="right pa-3" style="border: 1px solid #3BB8B2">
                              <v-card-text>
                                <v-layout row wrap>
                                  <template
                                      v-if="
                                      (!totalInvoiceData.totalTaxIVABase &&
                                        !totalInvoiceData.totalTaxIGICBase) ||
                                        (!totalInvoiceData.totalTaxIVABase &&
                                          totalInvoiceData.totalTaxIGICBase !==
                                            totalInvoiceData.totalTaxBase) ||
                                        (!totalInvoiceData.totalTaxIGICBase &&
                                          totalInvoiceData.totalTaxIVABase !==
                                            totalInvoiceData.totalTaxBase)
                                    "
                                  >
                                    <v-flex xs12>
                                      <span class="left mr-5 font-weight-bold">
                                        Base Imponible
                                      </span>
                                      <span class="right ml-5 font-weight-bold">
                                        {{ formatPrice(totalInvoiceData.totalTaxBase) }} €
                                      </span>
                                    </v-flex>
                                  </template>
                                  <!-- IVA Summary -->
                                  <template v-if="totalInvoiceData.totalTaxIVABase">
                                    <v-flex xs12>
                                      <span class="left mr-5 font-weight-bold">
                                        {{
                                          totalInvoiceData.totalTaxIGICBase
                                              ? 'Base Imponible IVA'
                                              : 'Base Imponible'
                                        }}
                                      </span>
                                      <span class="right ml-5 font-weight-bold">
                                        {{ formatPrice(totalInvoiceData.totalTaxIVABase) }} €
                                      </span>
                                    </v-flex>
                                    <v-flex class="mt-2" xs12 v-if="selectedTaxes.tax21">
                                      <template v-if="numberOfTaxes > 1">
                                        <span class="left mr-5">Base imponible IVA 21%</span>
                                        <span class="right ml-5">
                                          {{ formatPrice(itemsTax.tax21.base) }} €
                                        </span>
                                        <br />
                                      </template>
                                      <span class="left mr-5">IVA 21%</span>
                                      <span class="right ml-5">
                                        {{ formatPrice(totalInvoiceData.totalTax21) }} €
                                      </span>
                                    </v-flex>
                                    <v-flex class="mt-2" xs12 v-if="selectedTaxes.tax10">
                                      <template v-if="numberOfTaxes > 1">
                                        <span class="left mr-5">Base imponible IVA 10%</span>
                                        <span class="right ml-5">
                                          {{ formatPrice(itemsTax.tax10.base) }} €
                                        </span>
                                        <br />
                                      </template>
                                      <span class="left mr-5">IVA 10%</span>
                                      <span class="right ml-5">
                                        {{ formatPrice(totalInvoiceData.totalTax10) }} €
                                      </span>
                                    </v-flex>
                                    <v-flex class="mt-2" xs12 v-if="selectedTaxes.tax75">
                                      <template v-if="numberOfTaxes > 1">
                                        <span class="left mr-5">Base imponible IVA 7,5%</span>
                                        <span class="right ml-5">
                                          {{ formatPrice(itemsTax.tax75.base) }} €
                                        </span>
                                        <br />
                                      </template>
                                      <span class="left mr-5">IVA 7,5%</span>
                                      <span class="right ml-5">
                                        {{ formatPrice(totalInvoiceData.totalTax75) }} €
                                      </span>
                                    </v-flex>
                                    <v-flex class="mt-2" xs12 v-if="selectedTaxes.tax5">
                                      <template v-if="numberOfTaxes > 1">
                                        <span class="left mr-5">Base imponible IVA 5%</span>
                                        <span class="right ml-5">
                                          {{ formatPrice(itemsTax.tax5.base) }} €
                                        </span>
                                        <br />
                                      </template>
                                      <span class="left mr-5">IVA 5%</span>
                                      <span class="right ml-5">
                                        {{ formatPrice(totalInvoiceData.totalTax5) }} €
                                      </span>
                                    </v-flex>
                                    <v-flex class="mt-2" xs12 v-if="selectedTaxes.tax4">
                                      <template v-if="numberOfTaxes > 1">
                                        <span class="left mr-5">Base imponible IVA 4%</span>
                                        <span class="right ml-5">
                                          {{ formatPrice(itemsTax.tax4.base) }} €
                                        </span>
                                        <br />
                                      </template>
                                      <span class="left mr-5">IVA 4%</span>
                                      <span class="right ml-5">
                                        {{ formatPrice(totalInvoiceData.totalTax4) }} €
                                      </span>
                                    </v-flex>
                                    <v-flex class="mt-2" xs12 v-if="selectedTaxes.tax2">
                                      <template v-if="numberOfTaxes > 1">
                                        <span class="left mr-5">Base imponible IVA 2%</span>
                                        <span class="right ml-5">
                                          {{ formatPrice(itemsTax.tax2.base) }} €
                                        </span>
                                        <br />
                                      </template>
                                      <span class="left mr-5">IVA 2%</span>
                                      <span class="right ml-5">
                                        {{ formatPrice(totalInvoiceData.totalTax2) }} €
                                      </span>
                                    </v-flex>
                                    <v-flex class="mt-2" xs12 v-if="selectedTaxes.tax0">
                                      <template v-if="numberOfTaxes > 1">
                                        <span class="left mr-5">Base imponible IVA 0%</span>
                                        <span class="right ml-5">
                                          {{ formatPrice(itemsTax.tax0.base) }} €
                                        </span>
                                        <br />
                                      </template>
                                      <span class="left mr-5">IVA 0%</span>
                                      <span class="right ml-5">
                                        {{ formatPrice(totalInvoiceData.totalTax0) }} €
                                      </span>
                                    </v-flex>
                                  </template>
                                  <!-- IGIC Summary -->
                                  <template v-if="totalInvoiceData.totalTaxIGICBase">
                                    <v-flex
                                        xs12
                                        :class="{
                                        'mt-3':
                                          totalInvoiceData.totalTaxIVABase &&
                                          totalInvoiceData.totalTaxIGICBase,
                                      }"
                                    >
                                      <span class="left mr-5 font-weight-bold">
                                        {{
                                          totalInvoiceData.totalTaxIVABase
                                              ? 'Base Imponible IGIC'
                                              : 'Base Imponible'
                                        }}
                                      </span>
                                      <span class="right ml-5 font-weight-bold">
                                        {{ formatPrice(totalInvoiceData.totalTaxIGICBase) }} €
                                      </span>
                                    </v-flex>
                                    <v-flex class="mt-2" xs12 v-if="selectedTaxes.tax7">
                                      <template v-if="numberOfTaxes > 1">
                                        <span class="left mr-5">Base imponible IGIC 7%</span>
                                        <span class="right ml-5">
                                          {{ formatPrice(itemsTax.tax7.base) }} €
                                        </span>
                                        <br />
                                      </template>
                                      <span class="left mr-5">IGIC 7%</span>
                                      <span class="right ml-5">
                                        {{ formatPrice(totalInvoiceData.totalTax7) }} €
                                      </span>
                                    </v-flex>
                                    <v-flex class="mt-2" xs12 v-if="selectedTaxes.tax3">
                                      <template v-if="numberOfTaxes > 1">
                                        <span class="left mr-5">Base imponible IGIC 3%</span>
                                        <span class="right ml-5">
                                          {{ formatPrice(itemsTax.tax3.base) }} €
                                        </span>
                                        <br />
                                      </template>
                                      <span class="left mr-5">IGIC 3%</span>
                                      <span class="right ml-5">
                                        {{ formatPrice(totalInvoiceData.totalTax3) }} €
                                      </span>
                                    </v-flex>
                                  </template>
                                  <!-- IRPF Summary -->
                                  <v-flex class="mt-2" xs12 v-if="selectedIrpf.irpf19">
                                    <span class="left mr-5">IRPF 19%</span>
                                    <span class="right ml-5">
                                      {{ formatPrice(totalInvoiceData.totalIrpf19) }} €
                                    </span>
                                  </v-flex>
                                  <v-flex class="mt-2" xs12 v-if="selectedIrpf.irpf15">
                                    <span class="left mr-5">IRPF 15%</span>
                                    <span class="right ml-5">
                                      {{ formatPrice(totalInvoiceData.totalIrpf15) }} €
                                    </span>
                                  </v-flex>
                                  <v-flex class="mt-2" xs12 v-if="selectedIrpf.irpf7">
                                    <span class="left mr-5">IRPF 7%</span>
                                    <span class="right ml-5">
                                      {{ formatPrice(totalInvoiceData.totalIrpf7) }} €
                                    </span>
                                  </v-flex>
                                  <v-flex class="mt-2" xs12 v-if="selectedIrpf.irpf2">
                                    <span class="left mr-5">IRPF 2%</span>
                                    <span class="right ml-5">
                                      {{ formatPrice(totalInvoiceData.totalIrpf2) }} €
                                    </span>
                                  </v-flex>
                                  <v-flex class="mt-2" xs12 v-if="selectedIrpf.irpf1">
                                    <span class="left mr-5">IRPF 1%</span>
                                    <span class="right ml-5">
                                      {{ formatPrice(totalInvoiceData.totalIrpf1) }} €
                                    </span>
                                  </v-flex>
                                  <v-flex class="mt-2" xs12 v-if="totalSuplidos">
                                    <span class="left mr-5">Suplidos</span>
                                    <span class="right ml-5">
                                      {{ formatPrice(totalSuplidos) }} €
                                    </span>
                                  </v-flex>
                                </v-layout>
                                <v-divider class="mt-2 mb-2"></v-divider>
                                <v-flex xs12 class="mb-4">
                                  <span class="left mr-5 font-weight-bold font-size-12-rem">
                                    TOTAL
                                  </span>
                                  <span class="right ml-5 font-weight-bold font-size-12-rem">
                                    {{ formatPrice(totalInvoiceData.totalAmount) }} €
                                  </span>
                                </v-flex>
                                <v-flex
                                    xs12
                                    class="mt-5 mb-4"
                                    v-if="totalInvoiceData.totalDiscount"
                                >
                                  <span class="right" style="color: darkgrey; font-size: 1rem">
                                    {{
                                      `Incluye descuento de ${formatPrice(
                                          totalInvoiceData.totalDiscount,
                                      )}`
                                    }}
                                    €
                                  </span>
                                </v-flex>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 class="mt-5">
                            <h2 class="pl-3">
                              Más información
                            </h2>
                          </v-flex>
                          <v-flex xs12 md4 class="pa-3">
                            <v-select
                              class="pr-2"
                              v-model="globalIrpf"
                              :items="irpf"
                              item-text="text"
                              item-value="value"
                              label="Aplicar IRPF"
                              :readonly="true"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 md4 class="pa-3">
                            <v-select
                              class="pr-2"
                              v-model="invoiceForm.payment_method"
                              :items="availablePaymentMethods"
                              item-text="text"
                              item-value="value"
                              label="Método de pago"
                              :readonly="true"
                            ></v-select>
                          </v-flex>
                          <v-flex
                            xs12
                            md4
                            class="pa-3"
                            v-if="invoiceForm.payment_method === 'Transferencia'"
                          >
                            <v-text-field
                              class="pl-2"
                              v-model="invoiceForm.account_iban"
                              label="Cuenta bancaria - IBAN"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              outline
                              color="primary"
                              label="Observaciones"
                              v-model="invoiceForm.observations"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item key="content-tab-1">
                  <v-container style="height: 100%;" class="scroll-y bg-white">
                    <open-billing-invoice-preview
                      id="element-to-print"
                      :key="resetPreviewKey"
                      class="bg-white"
                      :invoice="invoiceForm"
                      :invoice-type="invoiceType"
                      :totalInvoiceData="totalInvoiceData"
                      :logo="logoBase64"
                      :selected-taxes="selectedTaxes"
                      :items-tax="itemsTax"
                      :total-suplidos="totalSuplidos"
                    ></open-billing-invoice-preview>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
      </v-snackbar>
    </v-layout>
  </div>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api';
import OpenBillingOrderItemComponent from '@/modules/openbilling/components/OpenBillingOrderItemComponent';
import moment from 'moment';
import OpenBillingInvoicePreview from '@/modules/openbilling/components/OpenBillingInvoicePreview';
import html2pdf from 'html2pdf.js';
import { irpf } from '@/modules/openbilling/helpers/taxHelper';
import {
  availablePaymentMethods,
  createEmptyItemsTax,
  createEmptySelectedIrpf,
  createEmptySelectedTaxes,
  createEmptyTotalSelectedInvoiceData,
  generateCalculatedTotalSelectedInvoice,
  invoiceCategories,
  itemTaxType,
  operationTypes
} from "@/modules/openbilling/helpers/invoiceHelper";
import {recursiveFrequency} from "@/modules/openbilling/helpers/invoices";

export default {
  name: 'OpenBillingInvoiceForm',
  components: {
    'open-billing-invoice-preview': OpenBillingInvoicePreview,
    'open-billing-order-item-component': OpenBillingOrderItemComponent,
  },
  props: {
    showModal: { type: Boolean, default: false },
    invoiceId: { type: [String, Number], default: null },
    rectifyInvoiceId: { type: [String, Number], default: null },
    cloneInvoiceId: { type: [String, Number], default: null },
    invoiceType: { type: String, default: 'factura' },
    presetData: { type: Object, default: null },
  },
  data() {
    return {
      tabs: ['Datos', 'Vista previa'],
      selectedTab: 0,
      resetPreviewKey: 0,
      orderItemsKey: 0,
      showInvoiceDatePicker: false,
      showInvoiceExpirationDatePicker: false,
      showContactModalForm: false,
      snack: false,
      snackText: '',
      snackColor: 'info',
      globalIrpf: '0',
      billingContacts: [],
      billingSeries: [],
      invoiceForm: {
        id: null,
        clavedat: null,
        code: null,
        openbilling_serie_id: null,
        date: null,
        expiration_date: null,
        status: 'Pendiente',
        invoice_category: null,
        operation_type: null,
        openbilling_profile_id: null,
        profile_name: null,
        profile_cif: null,
        profile_address: null,
        profile_city: null,
        profile_postal_code: null,
        profile_province: null,
        profile_country: null,
        profile_email: null,
        profile_phone: null,
        openbilling_contact_id: null,
        contact_name: null,
        contact_cif: null,
        contact_address: null,
        contact_city: null,
        contact_postal_code: null,
        contact_province: null,
        contact_country: null,
        contact_email: null,
        contact_phone: null,
        tax_base: null,
        total_amount: null,
        payment_method: null,
        observations: null,
        attached_file: null,
        order_items: [],
        rectify: false,
        rectify_invoice_id: null,
        rectify_invoice_code: null,
        invoice_to_rectify: null,
        account_iban: null,
        doc_type: null,
        blocked: null,
        recursive_frequency: null,
        recursive_end: null,
        recursive_auto_send: false,
      },
      totalInvoiceData: createEmptyTotalSelectedInvoiceData(),
      selectedTaxes: createEmptySelectedTaxes(),
      selectedIrpf: createEmptySelectedIrpf(),
      itemsTax: createEmptyItemsTax(),
      totalSuplidos: 0,
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        number: value => {
          const pattern = /^-?\d+\.?\d*$/;
          return pattern.test(value) || 'Este campo debe ser numérico.';
        },
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      previousContactId: null,
      refreshContactForm: 0,
      logoBase64: null,
      containSuplido: false,
    };
  },
  async mounted() {
    // Set according to the action
    if (this.presetData) {
      Object.keys(this.invoiceForm).forEach(key => {
        this.invoiceForm[key] = this.presetData[key];
      });
      this.calculateTotalInvoice();
      //this.loadBillingContacts();
      // this.loadBillingSeries();
    } else if (this.invoiceId) {
      // Edit
      await this.getInvoiceData();
      //this.loadBillingContacts();
      // this.loadBillingSeries();
    } else if (this.rectifyInvoiceId) {
      // Rectify new invoice
      await this.getInvoiceDataToRectify(this.rectifyInvoiceId);
      //this.loadBillingContacts();
      // this.loadBillingRectifyingSeries();
    } else if (this.cloneInvoiceId) {
      // Rectify new invoice
      await this.getInvoiceDataToClone(this.cloneInvoiceId);
      //this.loadBillingContacts();
      // this.loadBillingSeries();
    } else {
      // New invoice
      this.invoiceForm.payment_method = this.billingProfileDefaultPaymentMethod;
      // await this.loadBillingSeries();
      this.addOrderItem();
      //this.loadBillingContacts();
    }

    // if (this.currentProfileHasLogo) {
    //   this.getLogoBase64();
    // }
  },
  computed: {
    numberOfTaxes() {
      let numberOfTaxes = 0;
      const taxes = Object.entries(this.selectedTaxes);
      taxes.forEach(([key, value]) => {
        if (value === true) {
          numberOfTaxes = numberOfTaxes + 1;
        }
      });
      return numberOfTaxes;
    },
    show() {
      return this.showModal;
    },
    toolbarTitle() {
      if (this.invoiceId && this.invoiceType === 'factura') {
        return 'VER FACTURA';
      } else if (this.invoiceId && this.invoiceType === 'presupuesto') {
        return 'VER PRESUPUESTO';
      } else {
        return 'FACTURA';
      }
    },
    billingProfileId() {
      return this.$store.getters.currentOpenbillingProfileId;
    },
    billingProfileAccountIban() {
      return this.$store.getters.currentOpenbillingProfileAccountIban;
    },
    billingProfileDefaultPaymentMethod() {
      return this.$store.getters.currentOpenbillingProfileDefaultPaymentMethod;
    },
    clavedat() {
      return this.$store.state.clavedat;
    },
    selectedContactId() {
      return this.invoiceForm.openbilling_contact_id || null;
    },
    selectedPaymentMethod() {
      return this.invoiceForm.payment_method || null;
    },
    formattedInvoiceDate() {
      return this.invoiceForm.date ? moment(this.invoiceForm.date).format('DD/MM/YYYY') : '';
    },
    formattedRecursiveEndDate() {
      return this.invoiceForm.recursive_end
          ? moment(this.invoiceForm.recursive_end).format('DD/MM/YYYY')
          : '';
    },
    formattedInvoiceExpirationDate() {
      return this.invoiceForm.expiration_date
        ? moment(this.invoiceForm.expiration_date).format('DD/MM/YYYY')
        : '';
    },
    currentProfileHasLogo() {
      return this.$store.getters.currentOpenbillingProfile
        ? this.$store.getters.currentOpenbillingProfile['logo']
        : '';
    },
    defaultTax() {
      const serie = this.billingSeries.find(
        item => item.id === this.invoiceForm.openbilling_serie_id,
      );
      if (serie) {
        return serie.default_tax;
      } else {
        return '21';
      }
    },
    defaultIrpf() {
      const serie = this.billingSeries.find(
        item => item.id === this.invoiceForm.openbilling_serie_id,
      );
      if (serie) {
        return serie.default_irpf;
      } else {
        return '0';
      }
    },
    irpf() {
      return irpf;
    },
    selectedSerieId() {
      return this.invoiceForm.openbilling_serie_id;
    },
    invoiceCategories() {
      return invoiceCategories;
    },
    operationTypes() {
      return operationTypes;
    },
    availablePaymentMethods() {
      return availablePaymentMethods;
    },
    recursiveFrequencyOptions() {
      return recursiveFrequency;
    },
  },
  methods: {
    getLogoBase64() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/settings/logo/${this.billingProfileId}/base64`)
        .then(res => {
          this.logoBase64 = res.data;
        })
        .catch(() => {});
    },
    formatPrice(price) {
      if (price) {
        return price.toString().replace('.', ',');
      } else {
        return price;
      }
    },
    generatePDF() {
      let element = document.getElementById('element-to-print');
      let opt = {
        margin: 1,
        filename: `Factura_${this.invoiceForm.code}.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2, backgroundColor: '#ffffff' },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      };
      html2pdf()
        .set(opt)
        .from(element)
        .save();
    },
    showSnackMessage(action, message) {
      this.snackColor = action;
      this.snackText = message;
      this.snack = true;
    },
    onClickCloseModal() {
      this.$emit('click-on-close');
    },
    loadBillingContacts() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/contacts/${this.billingProfileId}/list`, {
          params: {
            page: 1,
            per_page: -1,
            sort_by: 'name',
            descending: true,
          },
        })
        .then(res => {
          this.billingContacts = res.data.data;
        });
    },
    loadBillingSeries() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/series/list-all`, {
          params: {
            sort_by: 'id',
            descending: true,
            type: this.invoiceType,
            rectifying: false,
          },
        })
        .then(res => {
          this.billingSeries = [
            {
              id: null,
              next_serie: 'Manual',
              manual_number: res.data['nextManualNumber'] ? res.data['nextManualNumber'] : '1',
              default: false,
              default_tax: '21',
              default_irpf: '0',
            },
          ];
          this.billingSeries = this.billingSeries.concat(res.data.data);
          this.billingSeries.forEach(serie => {
            // If it is creating and has default serie
            if (serie.default && !this.invoiceForm.id) {
              this.invoiceForm.openbilling_serie_id = serie.id;
              this.invoiceForm.code = serie.next_serie;
            }
            // If it is editing set the same as the invoice has set
            if (
              this.invoiceForm.id &&
              this.invoiceForm.openbilling_serie_id &&
              this.invoiceForm.openbilling_serie_id === serie.id
            ) {
              serie.next_serie = this.invoiceForm.code;
            }
          });

          // If it has not a default serie and it is creating a new invoice, set next manual number automatically.
          const defaultSerie = this.billingSeries.find(
            item => item.default === true || item.default === 1,
          );
          if (!defaultSerie && !this.invoiceForm.id) {
            const manualSerie = this.billingSeries.find(item => item.next_serie === 'Manual');
            this.invoiceForm.code = manualSerie.manual_number;
          }
        });
    },
    loadBillingRectifyingSeries() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/series/list-all`, {
          params: {
            sort_by: 'id',
            descending: true,
            type: 'factura',
            rectifying: true,
          },
        })
        .then(res => {
          this.billingSeries = [
            {
              id: null,
              next_serie: 'Manual',
              manual_number: res.data['nextManualNumber'] ? res.data['nextManualNumber'] : '1',
              default: false,
              default_tax: '21',
              default_irpf: '0',
            },
          ];
          this.billingSeries = this.billingSeries.concat(res.data.data);
          this.billingSeries.forEach(serie => {
            // If it is creating and has default serie
            if (serie.default && !this.invoiceForm.id) {
              this.invoiceForm.openbilling_serie_id = serie.id;
              this.invoiceForm.code = serie.next_serie;
            }
            // If it is editing set the same as the invoice has set
            if (
              this.invoiceForm.id &&
              this.invoiceForm.openbilling_serie_id &&
              this.invoiceForm.openbilling_serie_id === serie.id
            ) {
              serie.next_serie = this.invoiceForm.code;
            }
          });
          // If it has not a default serie and it is creating a new invoice, set next manual number automatically.
          const defaultSerie = this.billingSeries.find(
            item => item.default === true || item.default === 1,
          );
          if (!defaultSerie && !this.invoiceForm.id) {
            const manualSerie = this.billingSeries.find(item => item.next_serie === 'Manual');
            this.invoiceForm.code = manualSerie.manual_number;
          }
        });
    },
    addOrderItem() {
      const orderItem = {
        id: null,
        clavedat: this.clavedat,
        openbilling_invoice_id: this.invoiceId,
        description: null,
        quantity: 1,
        tax_base: null,
        discount_amount: 0,
        discount_type: 'percentage',
        tax: this.defaultTax,
        tax_amount: 0,
        irpf: this.globalIrpf,
        irpf_amount: 0,
        total_amount: 0,
        total_amount_with_taxes: 0,
        type: 'corriente',
      };
      this.invoiceForm.order_items.push(orderItem);
    },
    setContactData(contactId, contact = null) {
      if (!contact) {
        contact = this.billingContacts.find(item => item.id === contactId);
      }
      this.invoiceForm.openbilling_contact_id = contactId;
      if (contact) {
        this.invoiceForm.contact_name = contact.name;
        this.invoiceForm.contact_cif = contact.cif;
        this.invoiceForm.contact_address = contact.address;
        this.invoiceForm.contact_city = contact.city;
        this.invoiceForm.contact_postal_code = contact.postal_code;
        this.invoiceForm.contact_province = contact.province;
        this.invoiceForm.contact_country = contact.country;
        this.invoiceForm.contact_email = contact.contact_email;
        this.invoiceForm.contact_phone = contact.contact_phone;
      }
    },
    onOrderItemChanged($event) {
      this.invoiceForm.order_items[$event.index] = $event.orderItem;
      this.containSuplido = this.invoiceForm.order_items.some(item => item.type === 'suplido');
      this.calculateTotalInvoice();
    },
    onOrderItemTypeChanged($event) {
      if ($event['type'] === 'suplido') {
        this.globalIrpf = '0';
      }
      this.containSuplido = this.invoiceForm.order_items.some(item => item.type === 'suplido');
      this.calculateTotalInvoice();
    },
    itemTaxType(item) {
      return itemTaxType(item);
    },
    calculateTotalInvoice() {
      const calculatedData = generateCalculatedTotalSelectedInvoice(this.invoiceForm);
      this.totalInvoiceData = calculatedData['totalData'];
      this.invoiceForm = calculatedData['invoice'];
      this.itemsTax = calculatedData['itemsTax'];
      this.selectedTaxes = calculatedData['selectedTaxes'];
      this.selectedIrpf = calculatedData['selectedIrpf'];
      this.totalSuplidos = calculatedData['totalSuplidos'];
    },
    async getInvoiceData() {
      apiCtrl
        .get(`/openbilling/null/invoices/show/${this.invoiceId}`)
        .then(res => {
          const data = res.data.data;
          Object.keys(this.invoiceForm).forEach(key => {
            this.invoiceForm[key] = data[key];
          });
          // Set global IRPF according to the items of the invoice
          this.globalIrpf = this.invoiceForm.order_items[0].irpf;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async getInvoiceDataToRectify(invoiceId) {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/invoices/${invoiceId}/data-to-rectify`)
        .then(res => {
          const data = res.data.data;
          Object.keys(this.invoiceForm).forEach(key => {
            this.invoiceForm[key] = data[key];
          });
          // Set global IRPF according to the items of the invoice
          this.globalIrpf = this.invoiceForm.order_items[0].irpf;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async getInvoiceDataToClone(invoiceId) {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/invoices/${invoiceId}/data-to-clone`)
        .then(res => {
          const data = res.data.data;
          Object.keys(this.invoiceForm).forEach(key => {
            this.invoiceForm[key] = data[key];
          });
          // Set global IRPF according to the items of the invoice
          this.globalIrpf = this.invoiceForm.order_items[0].irpf;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChangeBillingSerie(event) {
      const serie = this.billingSeries.find(item => item.id === event);
      if (serie) {
        this.invoiceForm.code =
          serie.next_serie === 'Manual' ? serie.manual_number : serie.next_serie;
      }
    },
  },
  watch: {
    selectedContactId: function() {
      this.setContactData(this.selectedContactId);
    },
    selectedPaymentMethod: function() {
      if (this.selectedPaymentMethod === 'Transferencia') {
        this.invoiceForm.account_iban = this.billingProfileAccountIban;
      }
    },
    invoiceId: function() {
      if (this.invoiceId) {
        this.getInvoiceData();
      }
    },
    rectifyInvoiceId: function() {
      if (this.rectifyInvoiceId) {
        this.getInvoiceDataToRectify(this.rectifyInvoiceId);
      }
    },
    selectedSerieId: function(val) {
      // If has not id (creating) and only has 1 order item (default when create) we set the default values
      const serie = this.billingSeries.find(item => item.id === val);
      if (serie && !this.invoiceForm.id && this.invoiceForm.order_items.length === 1) {
        this.invoiceForm.order_items[0].tax = serie.default_tax;
        this.invoiceForm.order_items[0].irpf = serie.default_irpf;
        this.globalIrpf = serie.default_irpf;
      }
    },
    globalIrpf: function() {
      this.invoiceForm.order_items.forEach(item => (item.irpf = this.globalIrpf));
      this.orderItemsKey = this.orderItemsKey + 1;
    },
    invoiceForm: {
      deep: true,
      handler() {
        this.resetPreviewKey++;
      },
    },
  },
};
</script>

<style scoped>
.width-100 {
  width: 100%;
}
.font-size-12-rem {
  font-size: 1.2rem;
}

.bg-white {
  background-color: white;
}
</style>
